import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ABRIDGE_ACTIONS from '../../store/actions/AbridgeAction';
import { STORE_NAMES } from '../../constants/store.constants';
import Image from '../Image/Image';
import { PATIENT_CONSENT, ABRIDGE_STATUS_OPTIONS, NONE, NONE_NONMCE } from '../../constants/abridgePatientConsent.constants';

const AbridgeConsent = () => {
  const {
    abridgeConsentDetails: { status, mceEnabled }
  } = useSelector(state => state?.[STORE_NAMES.ABRIDGE]);
  const { meetingID } = useSelector(state => state?.[STORE_NAMES.ZOOM_CLIENT]);
  const {
    appointmentRegion: region = null,
    appointmentVisitType: visitType = null,
    provider: { nuid = '' } = {},
    appointmentId = null
  } = useSelector(state => state?.[STORE_NAMES.APPOINTMENT_DETAILS]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!meetingID) {
      return;
    }

    const payload = {
      zoomMeetingId: meetingID,
      region,
      visitType,
      appointmentId,
      providerId: nuid
    };
    dispatch(ABRIDGE_ACTIONS.fetchPatientAbridgeConsentAction(payload));
  }, [dispatch, meetingID, region, visitType, appointmentId, nuid]);

  const abridgeTypeStatus = status === NONE ? (mceEnabled ? NONE : NONE_NONMCE) : status;

  if (!ABRIDGE_STATUS_OPTIONS[status]) {
    return null;
  }

  return (
    <div className="vve-abridge-container">
      <p className="vve-patient-consent">{PATIENT_CONSENT}</p>
      <div className="vve-abridge-consent">
        <div className="vve-abridge-consent-header">
          <Image className="vve-abridge-consent-img" src={ABRIDGE_STATUS_OPTIONS[abridgeTypeStatus].icon} role="img" alt="patientNoneConsent.svg" />
          {ABRIDGE_STATUS_OPTIONS[abridgeTypeStatus].header}
        </div>
        <p className="vve-abridge-consent-info">{ABRIDGE_STATUS_OPTIONS[abridgeTypeStatus].info}</p>
        <p className="vve-abridge-consent-body">{ABRIDGE_STATUS_OPTIONS[abridgeTypeStatus].body}</p>
      </div>
    </div>
  );
};

export default AbridgeConsent;
